import CourseEditBlock, { CourseEditBlockProps } from './CourseEditBlock';
import withInteractor from './CourseEditBlock.interactor';
import withPresenter from './CourseEditBlock.presenter';

export type { CourseEditBlockProps };
export default withInteractor(withPresenter(CourseEditBlock));
